import styled from 'styled-components';
export const Root = styled.div `
    // .userinfo{
    //     display: flex;
    //     img {
    //         width: 120px;
    //         height: 90px;
    //         &:not(:first-child){
    //             margin-left:24px;
    //         }
    //     }
    //     .noData{
    //         color:#999999;
    //     }
    // }
    .userinfo{
        display: flex;
        span {
            margin-right: 8px;
        }
        img {
            width: 120px;
            height: 90px;
            &:not(:first-child){
                margin-left:24px;
            }
        }
        .coverImg {
            position:relative;
        }
        .cover{
            width: 120px;
            height: 90px;
            background-color: rgba(0,0,0,0.6);
            position:absolute;
            top:0;
            left:0;
            opacity:0;
            color:#fff;
            transition:.6s;
            i{
                position:absolute;
                left:45%;
                line-height:90px;
            }
        }
        .cover:hover{
            opacity:.6;
        }
        .noData{
            color:#999999;
        }
    }
`;
